//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Particles from "./components/Particles";
import InputCard from "./components/InputCard";

export default {
  components: {
    Particles,
    InputCard
  },
}

